import { render, staticRenderFns } from "./TennisLeague.vue?vue&type=template&id=75c9e20a&scoped=true&"
import script from "./TennisLeague.vue?vue&type=script&lang=js&"
export * from "./TennisLeague.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c9e20a",
  null
  
)

export default component.exports